import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * @deprecated values are still supported but can use standard xs, sm, lg, 2x ... notation
 */
export type IconSize = 'extra-small' | 'small' | 'medium' | 'large' | 'extra-large';

export interface IProps extends IntrinsicProps {
  /** The font-awesome icon name */
  icon: any;
  /** The color of the icon. Inherits color from parent by default. */
  color?: string;
  /** The size of the icon relative to it's parent font-size.
   * One of 'xs', 'sm', 'lg', '1x' (default) through to '10x'
   * legacy values (see deprecated IconSize type) are still supported */
  size?: string;
  /** When true the icon will spin. Defaults to false */
  spin?: boolean;
}

export const Icon = ({ size, ...props }: IProps) => {
  if (props.icon) {
    return (
      <FontAwesomeIcon
        data-testid="Icon"
        icon={props.icon}
        size={getSize(size)}
        color={props.color}
        spin={props.spin}
        {...props}
      />
    );
  } else {
    return null;
  }
};

function getSize(size) {
  switch (size) {
    case 'extra-small':
      return 'xs';
    case 'small':
      return 'sm';
    case 'large':
      return 'lg';
    case 'extra-large':
      return '2x';
    case 'medium':
      return '1x';
    default:
      return size;
  }
}

Icon.defaultProps = {
  size: 'medium',
};
